<script>
  export let feedWidth;
  export let feedHeight;
  import { debounce } from "./utils/helpers";
  let viewportWidth = window.innerWidth;
  let resize = false;
  function handleResize() {
    viewportWidth = window.innerWidth;
    resize = true;
    resize = false;
    FB.XFBML.parse();
  }
</script>

<svelte:window on:resize={debounce(handleResize, 250)} />
{#if !resize}
  <div
    class="fb-page"
    data-href="https://www.facebook.com/CaseyCrawfordMovement/"
    data-tabs="timeline"
    data-width={viewportWidth < 926 ? feedWidth : feedWidth - 84}
    data-height={feedHeight - 56}
    data-small-header="true"
    data-adapt-container-width="false"
    data-hide-cover="false"
    data-show-facepile="true"
  >
    <blockquote
      cite="https://www.facebook.com/CaseyCrawfordMovement/"
      class="fb-xfbml-parse-ignore"
    >
      <a href="https://www.facebook.com/CaseyCrawfordMovement/">
        Casey Crawford
      </a>
    </blockquote>
  </div>
{/if}
